import React from 'react'

const ContentContext = React.createContext()

ContentContext.displayName = `ContentContext`

export default ContentContext
